import moment from 'moment';
export const identity = (x) => x;
export const chunks = (array, size) => {
    return Array.from({ length: Math.ceil(array.length / size) }, (v, i) => array.slice(i * size, i * size + size));
};
export const combine = (...args) => args.filter(identity).join(' ');
// Date
export const getDaysInMonth = (date) => {
    const startWeek = moment(date).startOf('month').startOf('week').toDate();
    const endWeek = moment(date).endOf('month').endOf('week').toDate();
    const days = [];
    for (let curr = startWeek; moment(curr).isBefore(endWeek);) {
        days.push(curr);
        curr = moment(curr).add(1, 'day').toDate();
    }
    return days;
};
export const isStartOfRange = ({ startDate }, day) => (startDate && moment(day).isSame(startDate, 'day'));
export const isEndOfRange = ({ endDate }, day) => (endDate && moment(day).isSame(endDate, 'day'));
export const inDateRange = ({ startDate, endDate }, day) => (startDate && endDate && (moment(day).isBetween(startDate, endDate, undefined, '[]') || moment(day).isSame(startDate, 'day') || moment(day).isSame(endDate, 'day')));
export const isRangeSameDay = ({ startDate, endDate }) => {
    if (startDate && endDate) {
        return moment(startDate).isSame(endDate, 'day');
    }
    return false;
};
export const parseOptionalDate = (date, defaultValue) => {
    if (date instanceof Date) {
        const parsed = moment(date).toDate();
        if (moment(parsed).isValid())
            return parsed;
    }
    if (date instanceof String) {
        const parsed = moment(date).toDate();
        if (moment(parsed).isValid())
            return parsed;
    }
    return defaultValue;
};
export const getValidatedMonths = (range, minDate, maxDate) => {
    const { startDate, endDate } = range;
    if (startDate && endDate) {
        const newStart = moment.max([moment(startDate), moment(minDate)]).toDate();
        const newEnd = moment.min([moment(endDate), moment(maxDate)]).toDate();
        return [newStart, moment(newStart).isSame(newEnd, 'month') ? moment(newStart).add(1, 'month').toDate() : newEnd];
    }
    return [startDate, endDate];
};
export const FormatDateForInput = (date, format = 'mm/dd/yyyy') => {
    //Date -> mm/dd/yyyy
    if (date) {
        const dd = date.getDate();
        const mm = date.getMonth() + 1;
        return `${(mm < 10 ? '0' : '') + mm}/${(dd < 10 ? '0' : '') + dd}/${date.getFullYear()}`;
    }
    return '';
};
export const maskDateFormatter = (value, mask, maskInputChar = '_') => {
    const acceptRegexp = /[\d]/gi;
    return value
        .split('')
        .map((char, i) => {
        acceptRegexp.lastIndex = 0;
        if (i > mask.length - 1) {
            return '';
        }
        const maskChar = mask[i];
        const nextMaskChar = mask[i + 1];
        const acceptedChar = acceptRegexp.test(char) ? char : '';
        const formattedChar = maskChar === maskInputChar ? acceptedChar : maskChar + acceptedChar;
        if (i === value.length - 1 && nextMaskChar && nextMaskChar !== maskInputChar) {
            // add / after num input
            return formattedChar ? formattedChar + nextMaskChar : '';
        }
        return formattedChar;
    })
        .join('');
};
